<template>
  <article class="section section--full-width" v-if="loaded">
    <header class="section__header">
      <h1 class="section__title">Minha conta</h1>
    </header>

    <section class="minhaconta">
      <div class="minhaconta__profile">
        <div class="minhaconta__avatar">
          <img class="minhaconta__avatar-image" :src="doctor.profile_picture" />

          <span class="minhaconta__avatar-editar" @click="modalUserImage = true">
            Editar
          </span>

          <user-image
            :active="modalUserImage"
            @status="modalUserImage = $event"
            :image="doctor.profile_picture"
            @newImage="updateUser()"
          />
        </div>

        <div class="minhaconta__info">
          <h2 class="minhaconta__name">{{doctor.display_name || doctor.user.name}}</h2>

          <div class="minhaconta__specialty">
            <em class="minhaconta__specialty-name">
              {{ doctor['medical_specialties'].map(n => n.name).join(', ') }}
            </em>
            <em class="minhaconta__specialty-crm">
              CRM {{doctor.crm}}/{{ doctor.crm_regional }}
            </em>
          </div>
        </div>

        <div class="minhaconta__badges">
          <span class="chip minhaconta__badges-specialty" v-if="doctor.is_amb_especialization === true">
            Especialista
          </span>

          <span class="minhaconta__badges-grade">
            <dr-grade />
          </span>
        </div>
      </div>

      <div class="minhaconta__import">
          <!-- <router-link :to="{name: 'DoctorPatientsImport'}" class="btn btn-sm import" >
            <dr-icon class="icon" name="upload" color="white"></dr-icon>
            Importar dados
          </router-link> -->
      </div>
    </section>

    <section class="section__wrapper minhaconta__options" v-if="showForm" key="0">
      <ul class="section__nav tabbed-nav">
        <li
          v-for="(comp, $index) in componentList"
          class="tabbed-nav__item"
          :key="'comp' + $index"
          :class="activeComponent === comp.route ? 'active' : ''"
        >
          <router-link
            :to="{ name: comp.route }"
            @click.native="activeComponent = comp.route"
            class="tabbed-nav__link"
          >
            {{ comp.label }}
          </router-link>
        </li>
      </ul>
      <div class="section__body">
        <transition name="fade" mode="out-in">
          <router-view @updated="updateUser()" @reloadTour="$emit('reloadTour', 1)" :dataForm="dataForm"></router-view>
        </transition>
      </div>
    </section>
  </article>
</template>

<script>
import userImage from '@/components/modals/userImage'
import drGrade from '@/components/grade'

export default {
  components: {
    userImage,
    drGrade
  },
  data () {
    return {
      modalUserImage: false,
      loaded: false,
      showForm: true,
      key: new Date(),
      componentList: [
        {
          name: 'userForm',
          label: 'Meus dados',
          route: 'DoctorUserInfo'
        },
        {
          name: 'offices',
          label: 'Consultórios',
          route: 'DoctorUserOffices'
        },
        // {
        //   name: 'bankDetails',
        //   label: 'Dados bancários',
        //   route: 'DoctorUserBankDetails'
        // },
        // {
        //   name: 'presentation',
        //   label: 'Apresentação',
        //   route: 'DoctorUserPresentation'
        // },
        {
          name: 'signature',
          label: 'Assinatura digitalizada',
          route: 'DoctorUserSignature'
        },
        {
          name: 'certificate',
          label: 'Certificado digital',
          route: 'DoctorUserCertificates'
        },
        {
          name: 'configuration',
          label: 'Configurações',
          route: 'DoctorUserConfiguration'
        }
      ],
      doctor: {},
      dataForm: null,
      activeComponent: this.$router.currentRoute.name
    }
  },
  mounted () {
    this.updateUser()
  },
  methods: {
    updateUser () {
      this.fn_SHOW_PROGRESS()
      let url = this.fn_GET_PARENT_ROUTE(this.$route) === 'doctor' ? '/doctor' : `${this.fn_GET_PARENT_ROUTE(this.$route)}/doctor`
      this.$http.get(url, this.$store.getters.getAuthHeader).then(
        async (res) => {
          for (let field in res.data) {
            if (res.data[field] === false) {
              res.data[field] = 'false'
            }
          }

          const avatar = res.data.profile_picture
            ? `${process.env.ROOT_API}/s3/file/doctor/${res.data.id}/profile_picture`
            : res.data.user.gender === 'F'
              ? require('@/assets/img/f_default.png')
              : require('@/assets/img/m_default.png')

          this.doctor = {...res.data, profile_picture: avatar}

          let profile = {
            id: this.doctor.user.id,
            name: this.doctor.user.name,
            displayName: this.doctor.display_name,
            picture: avatar
          }

          this.$store.dispatch('setUserProfile', profile)
          this.dataForm = res.data
          this.loaded = true
          this.fn_HIDE_PROGRESS()
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      )
    }
  },
  filters: {
    TO_LOWER_CASE (value) {
      return `${(String(value)).charAt(0).toUpperCase()}${(String(value).toLowerCase()).slice(1)}`
    }
  },
  watch: {
    '$route.name': function (val) {
      const component = this.componentList.filter(c => c.route === val)
      if (component) {
        this.activeComponent = val
      }
    }
  }
}
</script>
